/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '@angular/common';
import * as i4 from '@angular/router';
import * as i5 from '@angular/forms';
import * as i6 from '../components/help-footer.component.ngfactory';
import * as i7 from '../../../../src/app/components/help-footer.component';
import * as i8 from '../../../../src/app/order/quote.component';
import * as i9 from '@angular/platform-browser';
import * as i10 from '../../../../src/app/order/currentOrder.service';
import * as i11 from '../../../../src/app/order/orderValidation';
var styles_QuoteComponent = [];
export var RenderType_QuoteComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_QuoteComponent, data: {} });
function View_QuoteComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'h1', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, [' ', ' ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef]), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.ORDER_TITLE'));
        var currVal_1 = i0.ɵunv(_v, 1, 1, i0.ɵnov(_v, 3).transform('ORDER.MAIN_COMPONENT.TITLE'));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_QuoteComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'h1', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, [' ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService,
            i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 1, 0, i0.ɵnov(_v, 2).transform('ORDER.QUOTE_REQUEST_UPPERCASE'));
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_QuoteComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive',
                'current']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 5, { links: 1 }), i0.ɵqud(603979776, 6, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 10).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0, 'access-denied-cursor': 1 }),
        i0.ɵdid(671744, [[6, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute,
            i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(),
            i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        i0.ɵpod({ 'fa fa-check': 0 }), (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.orderMenuVisibility.billing);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = 'current';
        _ck(_v, 3, 0, currVal_1);
        var currVal_4 = _ck(_v, 9, 0, true, !_co.orderValidation.isAddressValid());
        _ck(_v, 8, 0, currVal_4);
        var currVal_5 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/billing');
        _ck(_v, 10, 0, currVal_5);
        var currVal_6 = _ck(_v, 14, 0, _co.orderValidation.isBillingValid());
        _ck(_v, 13, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_2 = i0.ɵnov(_v, 10).target;
        var currVal_3 = i0.ɵnov(_v, 10).href;
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_7 = i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform('ORDER.MAIN_COMPONENT.MENU.BILLING'));
        _ck(_v, 15, 0, currVal_7);
    });
}
function View_QuoteComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive',
                'current']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 7, { links: 1 }), i0.ɵqud(603979776, 8, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 10).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0, 'access-denied-cursor': 1 }),
        i0.ɵdid(671744, [[8, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute,
            i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(),
            i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        i0.ɵpod({ 'fa fa-check': 0 }), (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.orderMenuVisibility.shipping);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = 'current';
        _ck(_v, 3, 0, currVal_1);
        var currVal_4 = _ck(_v, 9, 0, true, !_co.orderValidation.isBillingValid());
        _ck(_v, 8, 0, currVal_4);
        var currVal_5 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/shipping');
        _ck(_v, 10, 0, currVal_5);
        var currVal_6 = _ck(_v, 14, 0, _co.orderValidation.isShippingValid());
        _ck(_v, 13, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_2 = i0.ɵnov(_v, 10).target;
        var currVal_3 = i0.ɵnov(_v, 10).href;
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_7 = i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform('ORDER.MAIN_COMPONENT.MENU.SHIPPING'));
        _ck(_v, 15, 0, currVal_7);
    });
}
function View_QuoteComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive',
                'current']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 9, { links: 1 }), i0.ɵqud(603979776, 10, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 10).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0, 'access-denied-cursor': 1 }),
        i0.ɵdid(671744, [[10, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute,
            i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(),
            i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        i0.ɵpod({ 'fa fa-check': 0 }), (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.orderMenuVisibility.summary);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = 'current';
        _ck(_v, 3, 0, currVal_1);
        var currVal_4 = _ck(_v, 9, 0, true, !_co.orderValidation.isShippingValid());
        _ck(_v, 8, 0, currVal_4);
        var currVal_5 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/summary');
        _ck(_v, 10, 0, currVal_5);
        var currVal_6 = _ck(_v, 14, 0, _co.orderValidation.isOrderValid());
        _ck(_v, 13, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_2 = i0.ɵnov(_v, 10).target;
        var currVal_3 = i0.ɵnov(_v, 10).href;
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_7 = i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform('ORDER.MAIN_COMPONENT.MENU.SUMMARY'));
        _ck(_v, 15, 0, currVal_7);
    });
}
function View_QuoteComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive',
                'current']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 11, { links: 1 }), i0.ɵqud(603979776, 12, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 10).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0, 'access-denied-cursor': 1 }),
        i0.ɵdid(671744, [[12, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute,
            i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(),
            i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        i0.ɵpod({ 'fa fa-check': 0 }), (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 2, 0, _co.orderMenuVisibility.summary);
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = 'current';
        _ck(_v, 3, 0, currVal_1);
        var currVal_4 = _ck(_v, 9, 0, true, !_co.orderValidation.isAddressValid());
        _ck(_v, 8, 0, currVal_4);
        var currVal_5 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/summary');
        _ck(_v, 10, 0, currVal_5);
        var currVal_6 = _ck(_v, 14, 0, _co.orderValidation.isQuoteValid());
        _ck(_v, 13, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_2 = i0.ɵnov(_v, 10).target;
        var currVal_3 = i0.ɵnov(_v, 10).href;
        _ck(_v, 7, 0, currVal_2, currVal_3);
        var currVal_7 = i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform('ORDER.MAIN_COMPONENT.MENU.SUMMARY'));
        _ck(_v, 15, 0, currVal_7);
    });
}
export function View_QuoteComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 105, 'div', [['class',
                'row wrapper page-heading page-heading-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n	'])), (_l()(),
            i0.ɵeld(0, null, null, 7, 'div', [['class', 'col-lg-12 text-c']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n		'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_1)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n		'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_2)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n	'])), (_l()(), i0.ɵted(null, ['\n\n	'])),
        (_l()(), i0.ɵeld(0, null, null, 93, 'div', [['class', 'wrapper wrapper-content-bigger animated fadeIn order-max-width']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n\n		'])), (_l()(), i0.ɵted(null, ['\n		'])),
        (_l()(), i0.ɵeld(0, null, null, 61, 'div', [['class', 'steps steps-wizard clearfix']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n			'])), (_l()(), i0.ɵeld(0, null, null, 58, 'ul', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive', 'current']], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 1, { links: 1 }), i0.ɵqud(603979776, 2, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 28).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0 }), i0.ɵdid(671744, [[2, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute, i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'fa fa-check': 0 }),
        (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵeld(0, null, null, 17, 'li', [['routerLinkActive', 'current']], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }),
        i0.ɵdid(1720320, null, 2, i4.RouterLinkActive, [i4.Router, i0.ElementRef,
            i0.Renderer2, i0.ChangeDetectorRef], { routerLinkActive: [0, 'routerLinkActive'] }, null), i0.ɵqud(603979776, 3, { links: 1 }), i0.ɵqud(603979776, 4, { linksWithHrefs: 1 }),
        (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 47).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0,
                'ngClass'] }, null), i0.ɵpod({ 'btn-default': 0, 'access-denied-cursor': 1 }),
        i0.ɵdid(671744, [[4, 4]], 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute,
            i3.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(),
            i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(0, null, null, 2, 'i', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers,
            i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null),
        i0.ɵpod({ 'fa fa-check': 0 }), (_l()(), i0.ɵted(null, [' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_3)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_4)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_5)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_QuoteComponent_6)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵeld(0, null, null, 5, 'li', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), i0.ɵpod({ 'before-active': 0 }), (_l()(),
            i0.ɵted(null, ['\n					', ' ', '\n					'])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵted(null, ['\n			'])), (_l()(), i0.ɵted(null, ['\n		'])), (_l()(), i0.ɵted(null, ['\n		'])), (_l()(), i0.ɵted(null, ['\n\n		'])), (_l()(), i0.ɵted(null, ['\n\n		'])), (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'wizard']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n			'])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class',
                'content']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n\n				'])), (_l()(), i0.ɵted(null, ['\n				'])),
        (_l()(), i0.ɵeld(0, null, null, 16, 'div', [['class', 'content-wizard']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n\n					'])), (_l()(), i0.ɵeld(0, null, null, 9, 'form', [['class', 'p-lg'], ['name', 'signupForm'], ['ng-submit',
                'processForm()'], ['novalidate', '']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'submit'], [null,
                'reset']], function (_v, en, $event) {
            var ad = true;
            if (('submit' === en)) {
                var pd_0 = (i0.ɵnov(_v, 88).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
                var pd_1 = (i0.ɵnov(_v, 88).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i5.ɵbf, [], null, null), i0.ɵdid(16384, null, 0, i5.NgForm, [[8,
                null], [8, null]], null, null), i0.ɵprd(2048, null, i5.ControlContainer, null, [i5.NgForm]), i0.ɵdid(16384, null, 0, i5.NgControlStatusGroup, [i5.ControlContainer], null, null), (_l()(), i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵted(null, ['\n						'])), (_l()(), i0.ɵeld(16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)),
        i0.ɵdid(212992, null, 0, i4.RouterOutlet, [i4.ChildrenOutletContexts, i0.ViewContainerRef,
            i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null), (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵted(null, ['\n\n					'])), (_l()(), i0.ɵted(null, ['\n					'])), (_l()(), i0.ɵeld(0, null, null, 1, 'cx-helpfooter', [], null, null, null, i6.View_HelpFooterComponent_0, i6.RenderType_HelpFooterComponent)),
        i0.ɵdid(49152, null, 0, i7.HelpFooterComponent, [], null, null), (_l()(), i0.ɵted(null, ['\n\n				'])), (_l()(), i0.ɵted(null, ['\n				'])), (_l()(), i0.ɵted(null, ['\n\n			'])), (_l()(), i0.ɵted(null, ['\n		'])), (_l()(), i0.ɵted(null, ['\n\n	'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = _ck(_v, 20, 0, _co.orderMenuVisibility.part);
        _ck(_v, 19, 0, currVal_2);
        var currVal_3 = 'current';
        _ck(_v, 21, 0, currVal_3);
        var currVal_6 = _ck(_v, 27, 0, true);
        _ck(_v, 26, 0, currVal_6);
        var currVal_7 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/part');
        _ck(_v, 28, 0, currVal_7);
        var currVal_8 = _ck(_v, 32, 0, _co.orderValidation.isPartValid());
        _ck(_v, 31, 0, currVal_8);
        var currVal_10 = _ck(_v, 39, 0, _co.orderMenuVisibility.address);
        _ck(_v, 38, 0, currVal_10);
        var currVal_11 = 'current';
        _ck(_v, 40, 0, currVal_11);
        var currVal_14 = _ck(_v, 46, 0, true, !_co.orderValidation.isPartValid());
        _ck(_v, 45, 0, currVal_14);
        var currVal_15 = i0.ɵinlineInterpolate(1, '../', _co.orderType.lowercaseType, '/address');
        _ck(_v, 47, 0, currVal_15);
        var currVal_16 = _ck(_v, 51, 0, _co.orderValidation.isAddressValid());
        _ck(_v, 50, 0, currVal_16);
        var currVal_18 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 57, 0, currVal_18);
        var currVal_19 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 60, 0, currVal_19);
        var currVal_20 = (_co.orderType.lowercaseType == 'order');
        _ck(_v, 63, 0, currVal_20);
        var currVal_21 = (_co.orderType.lowercaseType == 'quote');
        _ck(_v, 66, 0, currVal_21);
        var currVal_22 = _ck(_v, 70, 0, _co.orderMenuVisibility.completed);
        _ck(_v, 69, 0, currVal_22);
        _ck(_v, 94, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_4 = i0.ɵnov(_v, 28).target;
        var currVal_5 = i0.ɵnov(_v, 28).href;
        _ck(_v, 25, 0, currVal_4, currVal_5);
        var currVal_9 = i0.ɵunv(_v, 33, 0, i0.ɵnov(_v, 34).transform('ORDER.MAIN_COMPONENT.MENU.PARTS'));
        _ck(_v, 33, 0, currVal_9);
        var currVal_12 = i0.ɵnov(_v, 47).target;
        var currVal_13 = i0.ɵnov(_v, 47).href;
        _ck(_v, 44, 0, currVal_12, currVal_13);
        var currVal_17 = i0.ɵunv(_v, 52, 0, i0.ɵnov(_v, 53).transform('ORDER.MAIN_COMPONENT.MENU.ADDRESS'));
        _ck(_v, 52, 0, currVal_17);
        var currVal_23 = _co.orderType.uppercaseLabel;
        var currVal_24 = i0.ɵunv(_v, 71, 1, i0.ɵnov(_v, 72).transform('ORDER.MAIN_COMPONENT.MENU.COMPLETED'));
        _ck(_v, 71, 0, currVal_23, currVal_24);
        var currVal_25 = i0.ɵnov(_v, 90).ngClassUntouched;
        var currVal_26 = i0.ɵnov(_v, 90).ngClassTouched;
        var currVal_27 = i0.ɵnov(_v, 90).ngClassPristine;
        var currVal_28 = i0.ɵnov(_v, 90).ngClassDirty;
        var currVal_29 = i0.ɵnov(_v, 90).ngClassValid;
        var currVal_30 = i0.ɵnov(_v, 90).ngClassInvalid;
        var currVal_31 = i0.ɵnov(_v, 90).ngClassPending;
        _ck(_v, 86, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31);
    });
}
export function View_QuoteComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-order', [], null, null, null, View_QuoteComponent_0, RenderType_QuoteComponent)),
        i0.ɵdid(49152, null, 0, i8.QuoteComponent, [i9.Title, i2.TranslateService,
            i10.CurrentOrderService, i11.OrderValidation], null, null)], null, null);
}
export var QuoteComponentNgFactory = i0.ɵccf('cx-order', i8.QuoteComponent, View_QuoteComponent_Host_0, {}, {}, []);
//# sourceMappingURL=quote.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/order/quote.component.ngfactory.js
// module id = 1198
// module chunks = 0